import { HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { AdapterInterface } from '../../types/global';
import { DemographicBreakdownOption } from '../../types/debt.type';

interface RawDemographicOption {
  filter_name: string;
  display_name: string;
}

export default class GetDemographicBreakdownOptions
  extends BaseAdapter<RawDemographicOption[]>
  implements AdapterInterface {
  rawResponse: RawDemographicOption[];

  async adaptResponse(): Promise<DemographicBreakdownOption[]> {
    await this.fetchApiResponse('/api/debt/pie-chart-dropdown-options', HTTPMethod.Get);
    return this.rawResponse.map((o) => ({
      filterName: o.filter_name,
      displayName: o.display_name,
    }));
  }
}
